import {createApp} from 'vue'
import Store from 'store'
import PriceToggle from './PriceToggle'

const component = createApp(PriceToggle).use(Store)

const el = '.nlx-component--price-toggle'
const DOM = document.querySelector(el)

if(DOM){
    component.mount(el)
}

